function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { useTranslation } from "@limitless/common/hooks";
import { usePortalHelp, useHelpDrawer } from "../../..";
import { log as pilog } from "@limitless/common/utils";
const useStyles = makeStyles({
  linkWrapper: {
    cursor: "help"
  }
});
const KnowledgeTypography = ({
  label,
  ...rest
}) => {
  const [category, setCategory] = React.useState(null);
  const [subCategory, setSubCategory] = React.useState(null);
  const [articleId, setArticleId] = React.useState(null);
  const {
    t
  } = useTranslation();
  const log = pilog.getLogger("KnowledgeTypography");
  const classes = useStyles();
  const {
    isHelpAvailable,
    openManagerHelp
  } = usePortalHelp();
  const {
    isDrawerOpen,
    toggleHelpDrawer
  } = useHelpDrawer();
  React.useEffect(() => {
    try {
      const kbTranslate = t(`kb_${label}`);
      const translation = kbTranslate.includes("kb_") ? "" : kbTranslate;
      if ((translation.match(RegExp("-", "g")) || []).length > 2) {
        setArticleId(translation);
      } else {
        const categories = translation.split("|");
        setCategory(categories[0]);
        if (categories.length > 1) {
          setSubCategory(categories[1]);
        }
      }
    } catch (e) {
      log.debug(" - Unable to translate label.");
    }
  }, []);
  const onClick = () => {
    if (!isDrawerOpen) {
      toggleHelpDrawer();
    }
    openManagerHelp(category, subCategory, articleId);
  };
  const renderKnowledgebaseLink = (category || articleId) && isHelpAvailable;
  const typography = /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "subtitle1"
  }, rest), t(label));
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderKnowledgebaseLink && /*#__PURE__*/React.createElement("div", {
    className: classes.linkWrapper,
    onClick: onClick
  }, typography), !renderKnowledgebaseLink && /*#__PURE__*/React.createElement(React.Fragment, null, typography));
};
export default KnowledgeTypography;
KnowledgeTypography.propTypes = {
  label: PropTypes.string
};